import {
  Breadcrumb,
  DocumentChartBarIcon,
  ErrorAlert,
  formatDate,
  PageHero,
  SearchToggle,
  TableRowsPerPage,
  useFetchData,
  useSearch,
} from "@";
import { DataTable } from "@/shared/components/tanstackTable";
import { getDetailedReport } from "./utils/api";
import MultiSearch from "./components/MultiSearch";
import ExportWithColumns from "./components/ExportWithColumns";
import { searchValues } from "./utils/options";
import tableColumns from "./components/tableColumns";

const Index = () => {
  const links = [
    { name: "التبرعات", link: "/donations" },
    { name: "التقارير", link: "" },
  ];

  const { search, updateSearch } = useSearch(searchValues);

  const { data, isLoading, error, pg, fetchData, updatePg } = useFetchData({
    fun: getDetailedReport,
    params: [search.values],
  });

  return (
    <>
      <ErrorAlert reload={fetchData} show={error} />
      <Breadcrumb links={links} />

      <main className="table-card relative">
        <PageHero
          eyebrow="التقارير / التبرعات"
          title="تقرير التبرعات التفصيلي"
          count={pg?.rows}
          icon={DocumentChartBarIcon}
          hideCount={isLoading}
        >
          <TableRowsPerPage
            pagination={pg}
            rowsPerPageOptions={[5, 10, 30, 50, 100, 200, "all"]}
            onRowsPerPageChange={(size) => updatePg({ size: size })}
          />

          <ExportWithColumns
            length={data?.length}
            search={search.values}
            updateSearch={updateSearch}
            headerText={` من تاريخ ${formatDate(search.values.fromDate) || ""}  إلى تاريخ ${formatDate(search.values.toDate) || ""} `}
            fileName={`من-تاريخ-${formatDate(search.values.fromDate) || ""}-إلى-تاريخ-${formatDate(search.values.toDate) || ""}`}
          />

          <SearchToggle toggle={() => updateSearch({ show: !search.show })} />
        </PageHero>

        <MultiSearch
          search={search}
          onSubmit={fetchData}
          dataLength={data?.length}
          updateSearch={updateSearch}
        />

        <DataTable
          data={data}
          columns={tableColumns}
          isLoading={isLoading}
          pagination={pg}
          onPageChange={(page) => updatePg({ page })}
          onPageSizeChange={(size) => updatePg({ size, page: 1 })}
          rowsPerPageOptions={[5, 10, 30, 50, 100, 200]}
        />
      </main>
    </>
  );
};

export default Index;
